import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

const Contact = () => {
  const [buttonText, setButtonText] = useState('Click Me');
  const [messageVisible, setMessageVisible] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  function handleClick(e) {
    e.preventDefault();
    setButtonText('Requesting...');

    // Simulate a request delay
    setTimeout(() => {
      setButtonText('Click Me');
      setMessageVisible(true);

      // Reset the input and textarea fields
      setName('');
      setEmail('');
      setMessage('');

      // Hide the message after a few seconds
      setTimeout(() => {
        setMessageVisible(false);
      }, 3000);
    }, 2000);
  }

  return (
    <section className='py-16 lg:section' id='contact'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row'>
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1'
          >
            <div>
              <h4 className='text-xl uppercase text-accent font-medium mb-2 tracking-wide'>Get in Touch</h4>
              <h2 className='text-[45px] lg:text-[90px] leading-none mb-12'>Lets work <br></br>Together!</h2>
            </div>
          </motion.div>

          <form className='flex-1 border rounded-2xl flex flex-col gap-y-6 pb-24 p-6 items-start'>
            <input
              className='bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all'
              type='text'
              placeholder='Your Name'
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              className='bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all'
              type='text'
              placeholder='Your Email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <textarea
              className='bg-transparent border-b py-12 outline-none w-full placeholder:text-white focus:border-accent transition-all resize-none mb-12'
              placeholder='Your Message..'
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
            <button className='btn btn-sm' onClick={handleClick}>
              {buttonText}
            </button>
            {messageVisible && <p>Request Completed</p>}
          </form>

          <div></div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
